
const updateLog = [
    {
        "time": "2024/04/25",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增河北地区新界面电子税务局的一键取票与税种采集",
                    "2、批量报税-生产经营模块已取数生产经营的企业标记为绿色，方便客户识别",
                    "3、票据合并模块新增发票类型筛选",
                    "4、账套迁移模块新增导入诺诺云财务软件"
                ]
            }
        ]
    },
    {
        "time": "2024/04/18",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增江西地区新界面电子税务局一般纳税人增值税和小规模增值税，财务报表季报和年报，企业所得税，印花税、残疾人保障金年报、工会经费、水利建设申报与检查",
                    "2、新增贵州地区的季报印花税",
                    "3、新增金账师企微功能",
                    "4、新增系统日志功能（管理员账号）"
                ]
            }
        ]
    },
    {
        "time": "2024/04/17",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "2024年4月报税期即将结束，为了保证已提交的任务正常运行，提交申报的功能即将在4月18号下午4点钟下线，请做好申报规划，以免发生漏申报的情况。"                ]
            }
        ]
    },
    {
        "time": "2024/04/11",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增上海地区新界面电子税务局的税种采集",
                    "2、新增安徽地区新界面电子税务局的垃圾费申报",
                    "3、新增广东地区新界面电子税务局的消费税和文化事业建设申报",
                    "4、新增贵州地区代理业务登录",
                    "5、登录信息模块新增电子税局扣款银行账号字段",
                    "6、归档模块新增存货数量辅助核算明细账导出",
                    "7、票据模块做账习惯凭证摘要新增单位全称选项",
                    "8、优化重复人员（未启用）信息导入",
                ]
            }
        ]
    },
    {
        "time": "2024/04/03",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增上海地区新界面电子税务局的一键取票、一般纳税人增值税、小规模增值税、财务报表（季月报、年报）、企业所得税、印花税申报、检查、扣款",
                    "2、新增安徽地区新界面电子税务局的小规模增值税、季报财务报表、企业所得税、印花税、文化建设申报",
                    "3、新增福建地区新界面电子税务局的小规模增值税、季报财务报表、企业所得税申报",
                    "4、新增陕西地区代理业务登录",
                    "5、批量操作-税种采集模块添加批量新增税种设置功能",
                    "6、一键取票新增采集未认证（仅当月）选项",
                ]
            }
        ]
    },
    {
        "time": "2024/03/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增辽宁地区工商年报申报",
                    "2、新增湖北地区工商年报采集",
                    "3、广州地区工商年报采集与申报上线",
                    "4、新增批量操作-一键取票模块可导出一键取票企业列表",
                    "5、新增记账收费模块可导出收费表",
                    "6、票据审核模块新增支持商品名称搜索",
                ]
            }
        ]
    },
    {
        "time": "2024/03/21",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增江苏、浙江(除宁波）、湖南、河北地区代理业务登录",
                    "2、新增辽宁地区工商年报采集",
                    "3、登录信息模块新增代理业务登录方式",
                    "4、新增工资表冻结表头",
                    "5、明细账查询的凭证新增红冲按钮",
                    "6、打印预览待打印项默认勾选取消",
                    "7、打印工资表新增年终奖字段",
                    "8、优化重复人员信息导入"
                ]
            }
        ]
    },
    {
        "time": "2024/03/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "2024年3月报税期即将结束，为了保证已提交的任务正常运行，提交申报的功能即将在3月15号下午5点钟下线，请做好申报规划，以免发生漏申报的情况。"                ]
            }
        ]
    },
    {
        "time": "2024/03/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增广东地区新界面电子税务局的一般纳税人增值税、年报财务报表申报与检查（下载申报表）",
                    "2、新增安徽地区新界面电子税务局的税种作废与检查（下载申报表）",
                    "3、新增福建地区新界面电子税务局的年报残保金、年报财务报表申报与税种作废与和检查（下载申报表）",
                    "4、新增湖南地区新界面电子税务局的税种作废与扣款",
                    "5、新增大连地区新界面电子税务局的一键取票，税种采集与一般纳税人增值税申报",
                    "6、新增江西地区新界面电子税务局的一键取票与税种采集",
                    "7、新增江西、河北地区工商年报申报",
                    "8、新增辽宁工商年报申报表"
                ]
            }
        ]
    },
    {
        "time": "2024/03/07",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增青海地区个税申报",
                    "2、新增广东新界面电子税务局的税种采集，一键取票，社保申报与社保扣款",
                    "3、新增安徽新界面电子税务局的一般纳税人增值税，工会经费，水利建设，年报财务报表申报",
                    "4、新增福建新界面电子税务局的一般纳税人增值税申报",
                    "5、新增山东地区工商年报采集与申报",
                    "6、新增江西地区工商年报采集",
                    "7、新增湖北工商年报的充装单位许可证模块",
                    "8、账套迁移模块新增导入企明星和润茂财税财务软件"
                ]
            }
        ]
    },
    {
        "time": "2024/02/29",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增广东（除广州、深圳、珠海）地区工商年报采集与申报",
                    "2、新增云南地区工商年报申报",
                    "3、新增河北地区工商年报采集",
                    "4、批量操作模块-一键取票添加取票时间显示",
                    "5、优化复制凭证与红冲凭证功期间选择",
                    "6、日记账模块匹配兴业银行对账单导入"
                ]
            }
        ]
    },
    {
        "time": "2024/02/23",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "2024年2月报税期即将结束，为了保证已提交的任务正常运行，提交申报的功能即将在2月23号下午5点钟下线，请做好申报规划，以免发生漏申报的情况。"                ]
            }
        ]
    },
    {
        "time": "2024/02/22",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增辽宁（除大连）地区社保申报、社保扣款、社保作废",
                    "2、新增青岛新界面电子税务局的检查（下载申报表）",
                    "3、新增湖南地区工商年报采集与申报",
                    "4、新增云南地区工商年报采集",
                    "5、新增广东（除广州，深圳，珠海）地区工商年报采集",
                    "6、红冲凭证功能支持期间选择",
                    "7、账套迁移模块新增导入大账房财务软件",
                    "8、优化新版账套迁移工具3.0末级科目无法删除问题"
                ]
            }
        ]
    },
    {
        "time": "2024/02/1",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增安徽地区工商年报申报",
                    "2、新增青岛新界面电子税务局的社保申报与社保扣款",
                    "3、新增湖南工商年报申报表",
                    "4、日记账模块新增上缴房产税、向银行贷款、还银行贷款、支付运输费、支付办公费收支类型与模板",
                    "5、优化取票批量导入提示信息"
                ]
            }
        ]
    },
    {
        "time": "2024/01/25",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、江苏、天津地区工商年报采集与申报上线",
                    "2、新增安徽工商年报采集",
                    "3、河北电子税务局社保升级，优化社保申报、作废、扣款",
                    "4、员工信息模块新增是否扣除减除费用字段与境外人员新增其他证照类型与其他证照号码字段",
                    "5、日记账导入匹配微信导出的对账单excel格式",
                    "6、账套迁移模块新增导账匹配唯易与优化金财代账凭证带辅助excel格式废"
                ]
            }
        ]
    },
    {
        "time": "2024/01/18",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增山东新界面电子税务局的一般纳税人增值税，小规模增值税，季报财务报表，企业所得税，季报印花税申报",
                    "2、新增青岛新界面电子税务局的一般纳税人增值税，小规模增值税，季报财务报表，企业所得税，季报印花税申报",
                    "3、新增四川小规模增值税，企业所得税，季报印花税申报",
                    "4、新增重庆小规模增值税，季报财务报表，企业所得税申报",
                    "5、新增湖南、天津新界面电子税务局的检查（下载申报表）",
                    "6、新增湖北电子税务局作废",
                    "7、优化账套迁移模块的科目匹配和凭证号收付转，兼容金财互联带辅助核算的凭证列表",
                    "8、优化增值税票客户名称、生产经营表人员信息长度"
                ]
            }
        ]
    },
    {
        "time": "2024/01/11",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增湖南新界面电子税务局的一般纳税人增值税，小规模增值税，季报财务报表，企业所得税，季报印花税，水利建设，工会经费，文化建设，残疾人保障金申报",
                    "2、新增天津新界面电子税务局的小规模增值税，季报财务报表，企业所得税，季报印花税，工会经费申报",
                    "3、辅助核算余额表存货数量金额式余额表下载支持隐藏科目",
                    "4、优化人员信息受雇类型为其他必须填写手机号"
                ]
            }
        ]
    },
    {
        "time": "2024/01/04",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增湖南、陕西、山东地区登录验证功能",
                    "2、新增湖南新界面电子税务局的税种采集、一键取票、一键登录与勾选认证功能",
                    "3、批量报税模块可输入公司名称或客户编码或标签搜索",
                    "4、批量操作模块可输入公司名称或客户编码或标签搜索",
                    "5、批量操作-一键取票模块征期内可选择当前月份"
                ]
            }
        ]
    },
    {
        "time": "2023/12/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增江苏、上海、安徽、北京、宁波、河北、辽宁、大连、山西、云南地区登录验证功能",
                    "2、新增重庆地区的一键登录与勾选认证功能",
                    "3、新增重庆电子税务局税种采集与一键取票",
                    "4、现金流量表明细新增导出功能",
                ]
            }
        ]
    },
    {
        "time": "2023/12/21",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增个税更正功能",
                    "2、批量复制凭证功能可直接复制到后面未做账的账期内",
                    "3、资产模块新增导出功能",
                    "4、优化生成经营申报表取数功能",
                    "5、优化工资表回写导入功能兼容年终奖格式",
                    "6、优化差额征税发票导入机制"
                ]
            }
        ]
    },
    {
        "time": "2023/12/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增四川地区一般纳税人增值税申报",
                    "2、新增上海地区社保申报，作废，扣款",
                    "3、新增安徽地区社保特殊缴费确认申报",
                    "4、调整江苏社保申报，且江苏社保申报好可直接提交扣款（江苏电子税务局社保升级）",
                    "5、民间非营利组织会计制度的企业可提交社保申报",
                    "6、新增报税任务模块，通过‘税’-‘批量报税’模块提交的报税可以在‘报税任务’模块可查看，可搜索（根据公司名称或申报结果模糊搜索），异常的可重新提交，等待中的可删除。"
                ]
            }
        ]
    },
    {
        "time": "2023/12/07",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、客户列表模块编码排序新增记忆功能",
                    "2、优化一键取票批量导入失败企业提示",
                    "3、增值税票-合并模块发票生成的凭证可查看附单据",
                    "4、凭证列表附单据可查询发票图片",
                    "5、资产模块的资产类别可悬浮显示"
                ]
            }
        ]
    },
    {
        "time": "2023/11/30",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "１、工资表新增可选择一页显示10/25/50条",
                    "２、优化做账习惯凭证摘要",
                    "３、资产模块优化导入模板",
                    "４、优化工资表导入失败人员提示",
                    "５、优化导出客户列表信息文件可兼容导入税务信息"
                ]
            }
        ]
    },
    {
        "time": "2023/11/23",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键取票月份延长近12个月",
                    "2、一般纳税人增值税主表25行一般项目的本月数可自行填写",
                    "3、优化民间非营利组织制度的资产负债表",
                    "4、财务软件客户端可复制税模块申报详情里面的图片",
                    "5、优化增值税票红冲机制"
                ]
            }
        ]
    },
    {
        "time": "2023/11/09",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增天津新电子税务局的增值税，文化税，消费税申报",
                    "2、新增天津电子税务局房产税与城镇土地使用税（半年）",
                    "3、优化数量外币余额表固定科目编码、科目名称、单位和币种字段"
                ]
            }
        ]
    },
    {
        "time": "2023/11/09",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、结转模块计提税金新增科目设置",
                    "2、结转模块计提印花税新增科目设置",
                    "3、批量操作-税种采集模块采集时间可区间筛选",
                    "4、优化科目辅助余额表,数量金额余额表,外币金额余额表固定编码、名称和单位字段"
                ]
            }
        ]
    },
    {
        "time": "2023/11/02",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增陕西地区水利建设申报",
                    "2、新增天津新电子税务局的税种采集与一键取票",
                    "3、新增撤销发票采集功能，取票状态是等待中的可撤销发票采集任务",
                    "4、优化打印明细账一级科目"
                ]
            }
        ]
    },
    {
        "time": "2023/10/26",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增陕西地区财务报表，企业所得税，小规模增值税申报",
                    "2、新增青岛地区残保金申报",
                    "3、优化明细账，显示本年累计有发生额或有余额的科目",
                    "4、优化断号检查，同一年之内当结账多个月份时可以检查结账其月份是否有断号",
                    "5、优化工资表的实发工资合计数"
                ]
            }
        ]
    },
    {
        "time": "2023/9/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增大连地区企业所得税、印花税（按期）申报",
                    "2、新增四川地区财务报表申报",
                    "3、客户列表标签可悬浮查看",
                    "4、工资表模块新增实发工资字段"
                ]
            }
        ]
    },
    {
        "time": "2023/9/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、数电发票影像采集上线地区：安徽，辽宁，福建，广东，云南，大连，浙江，天津，上海，山东，湖南，江苏，江西，宁波，北京，青岛，山西，贵州",
                    "2、新增大连地区小规模增值税、财务报表申报",
                    "3、新增山西社保申报",
                    "4、江西、河北、北京、上海、山东、青岛、四川地区优化新版登录",
                    "5、资产模块新增资产类别筛选",
                    "6、优化明细账显示、筛选与下载",
                ]
            }
        ]
    },
    {
        "time": "2023/9/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、结转模块新增批量生成凭证功能",
                    "2、明细账模块新增科目筛选功能，并且关联下载",
                    "3、优化发票影像导入功能",
                    "4、优化批量回写，取消月份限制息",
                    "5、优化管理员账户审核凭证权限，取消其权限限制",
                ]
            }
        ]
    },
    {
        "time": "2023/9/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增安徽地区垃圾费申报",
                    "2、新增大连地区工会经费申报",
                    "3、新增山西地区电子税务局扣款",
                    "4、登录信息模块电子税务局新增新版旧版登录方式，并且可自行导入登录信息",
                    "5、日记账导入匹配大连银行",
                ]
            }
        ]
    },
    {
        "time": "2023/9/7",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、江苏，湖南，安徽，上海，山东，北京，福建，辽宁，山西，四川，河北，云南，贵州，大连地区优化新版登录",
                    "2、增值税票新增发票影像的上传与打印功能",
                    "3、资产模块新增备注字段",
                    "4、工资表模块根据个人所得税有关专项附加扣除标准新政策做调整",
                    "5、管理员账户可备注账套权限",
                ]
            }
        ]
    },
    {
        "time": "2023/8/31",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、批量操作模块税种采集列表支持根据结果信息搜索，并且新增税种采集客户结果信息下载功能",
                    "2、归档新增利润表季报pdf下载",
                    "3、完善科目余额表查询筛选小记优化",
                    "4、优化记账模块-客户列表导出功能",
                    "5、调整生产经营默认征收方式为查账征收",
                ]
            }
        ]
    },
    {
        "time": "2023/8/24",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增四川地区一键登录、勾选认证、税种采集和取票功能",
                    "2、新增通过明细账查询凭证时可删除凭证功能",
                    "3、税种采集模块新增采集时间",
                    "4、新增资产模块资产名称悬浮功能",
                    "5、完善客户列表导出",
                ]
            }
        ]
    },
    {
        "time": "2023/8/10",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增大连地区一般纳税人增值税申报与作废",
                    "2、登录信息个税新增部门编号",
                    "3、优化无需申报的设置",
                    "4、优化一般纳税人附表一",
                ]
            }
        ]
    },
    {
        "time": "2023/8/3",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录新增贵州、大连新版登录方式",
                    "2、新增大连地区税务数字账户取票与税种认定信息采集",
                    "3、勾选认证功能新增大连地区",
                    "4、新增数量金额明细账可编辑凭证",
                    "5、完善生产经营取数功能",
                    "6、优化固定资产模块",
                ]
            }
        ]
    },
    {
        "time": "2023/7/27",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、税-电子税务局模块新增可选择单个或多个税种（财务报表、增值税、企业所得税、其他税种）提交申报",
                    "2、税-生产经营模块新增批量取数功能",
                    "3、日记账模块新增分页功能",
                    "4、记账收费列表新增客户编码搜索",
                ]
            }
        ]
    },
    {
        "time": "2023/7/13",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增云南、辽宁、湖北季报印花税申报",
                    "2、新增山西财务报表申报与电子税务局作废",
                    "3、新增吉林、大连个税申报",
                    "4、资产模块新增批量删除功能",
                    "5、日记账合并模块新增收支类型筛选"
                ]
            }
        ]
    },
    {
        "time": "2023/7/6",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录功能新增安徽新版登录方式",
                    "2、新增云南财务报表申报",
                    "3、新增凭证选择科目时可看到科目的余额",
                    "4、凭证列表可选择一页显示多少条凭证",
                    "5、记账收费、收费对账模块可选择一页显示多少条账套",
                    "6、库存模块数量单价调整为四位小数"
                ]
            }
        ]
    },
    {
        "time": "2023/6/29",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、湖南、江西、山东、安徽地区取票更新为税务数字账户",
                    "2、湖南、江西、山东、安徽地区勾选认证功能更新切换到税务数字账户",
                    "3、一键登录功能新增山东、湖南、河北、江西新版登录方式",
                    "4、网页版金账师财务软件可打开多个账套",
                    "5、记账收费、收费对账模块新增记账会计筛选",
                    "6、明细账下载包含有下级科目或辅助核算的一级科目的明细",
                    "7、民间非盈利组织的业务活动表可以直接下载",
                    "8、新增凭证中可粘贴含有千分符的数字",
                ]
            }
        ]
    },
    {
        "time": "2023/6/16",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增广东（除深圳、珠海）地区工商年报申报",
                    "2、新增海南、黑龙江地区个税申报",
                    "3、新增河北房产税申报",
                    "4、登录信息个税添加主管科所分局",
                    "5、日记账新增匹配上海农商行对账单",
                ]
            }
        ]
    },
    {
        "time": "2023/6/9",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增广州与天津地区工商年报申报",
                    "2、一键登录功能新增北京新版登录方式",
                    "3、优化复制上月工资功能",
                    "4、优化票据增值税票一键导入限制备注长度",
                    "5、修复银企互联-平安银行问题",
                ]
            }
        ]
    },
    {
        "time": "2023/6/2",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、河北与湖北地区取票更新为税务数字账户",
                    "2、河北与湖北地区勾选认证功能更新切换到税务数字账户",
                    "3、优化工资申报回写功能，不覆盖企业部分社保",
                    "4、自然人扣缴列表添加标签搜索",
                    "5、凭证汇总表打印显示凭证张数",
                ]
            }
        ]
    },
    {
        "time": "2023/5/26",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录功能新增山西、湖北新版登录方式",
                    "2、上海、浙江（除宁波）地区取票可获取出口退税勾选确认的发票",
                    "3、增值税票模块新增销项导出与进项导出表格文件功能",
                    "4、优化库存明细账与汇总表固定商品名称等列",
                    "5、日记账做账习惯摘要类型新增日记账摘要勾选",
                    "6、税务采集新增刷新按钮"
                ]
            }
        ]
    },
    {
        "time": "2023/5/19",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录功能新增深圳新版登录方式",
                    "2、江苏地区取票可获取出口退税勾选确认的发票",
                    "3、短信列表添加工商联络员手机号搜索",
                    "4、添加工商年报短信检测",
                    "5、调整日记账摘要生成规则，当不勾选的时候按日记账摘要生成凭证摘要",
                    "6、优化金账师会计助手，可在线预览PDF"
                ]
            }
        ]
    },
    {
        "time": "2023/5/12",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增工商年报模块与工商年报申报表",
                    "2、JZSgpt智能客服上线",
                    "3、新增江苏地区工商年报申报",
                    "4、一键登录功能新增上海、辽宁新版登录方式",
                    "5、辽宁地区取票更新为税务数字账户",
                    "6、辽宁地区勾选认证功能更新切换到税务数字账户",
                    "7、科目辅助余额表添加辅助核算筛选功能",
                    "8、票据模块新增合并按钮"
                ]
            }
        ]
    },
    {
        "time": "2023/4/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录功能新增江苏新版登录方式",
                    "2、江苏、福建、山西、云南、宁波、深圳地区取票更新为税务数字账户",
                    "3、江苏、福建、山西、云南、宁波、深圳地区勾选认证功能更新切换到税务数字账户",
                ]
            }
        ]
    },
    {
        "time": "2023/4/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、浙江地区（除宁波）取票更新为税务数字账户",
                    "2、票据导入兼容江苏税务数字账户导出格式",
                    "3、优化固定资产模块",
                ]
            }
        ]
    },
    {
        "time": "2023/4/21",
        "content": [
            {
                "title": "系统升级维护通知",
                "list": [
                    "尊敬的用户，为了更好的为您提供产品服务，将于2023-4-23 21:00至2023-4-24 00：00进行系统升级，请提前安排工作。因升级给您带来的不便，敬请谅解，感谢您的支持。",
                ]
            }
        ]
    },
    {
        "time": "2023/4/21",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增湖北地区小规模增值税，小企业会计准则的财务报表，企业所得税，次报印花税申报",
                    "2、新增贵州地区年报财务报表，工会经费申报",
                    "3、新增辽宁地区次报印花税、企业所得税，工会经费申报",
                    "4、新增云南地区一般纳税人增值税申报",
                    "5、新增山西地区工会经费申报",
                    "6、新增天津地区检查功能",
                    "7、一键登录功能新增浙江新版登录方式",
                    "8、优化生产经营个税所得税申报表，收入总额，成本费用，利润调整为可填写",
                    "9、优化结账模块"
                ]
            }
        ]
    },
    {
        "time": "2023/4/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增山西地区小规模增值税、企业所得税、印花税申报",
                    "2、新增云南地区小规模增值税、小企业会计准则的财务报表、企业所得税申报",
                    "3、新增贵州地区小规模增值税、小企业会计准则的财务报表、企业所得税申报",
                    "4、新增辽宁地区小规模增值税、小企业会计准则的财务报表申报",
                    "5、新增浙江（除宁波）一般企业会计准则的财务报表",
                    "6、新增江苏地区城镇土地使用税申报",
                    "7、归档模块年度新增辅助核算余额表与数量余额表",
                    "8、增值税票做账习惯设置新增是否自动设置单位",
                    "9、增值税票搜索新增价税合计与开票日期搜索功能"
                ]
            }
        ]
    },
    {
        "time": "2023/4/7",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增陕西地区年报财务报表申报",
                    "2、新增工资表回写功能",
                    "3、新增客户列表按客户编码排序功能",
                    "4、员工辅助支持筛选后数据导出表格文件",
                    "5、批量操作模块税种采集与一键取票界面新增失败原因数据显示",
                    "6、增值税票模块发票数量调整为四位小数",
                    "7、优化企业所得税申报表",
                    "8、优化外币明细账表格导出"
                ]
            }
        ]
    },
    {
        "time": "2023/3/31",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增云南地区年报财务报表申报",
                    "2、新增云南地区电子税务局取票",
                    "3、一键登录功能新增湖北、山西地区",
                    "4、勾选认证功能新增河北、安徽、山西地区",
                    "5、一键登录功能新增宁波新版登录方式",
                    "6、河北地区新增城镇土地使用税申报",
                    "7、出入库单据打印新增自定义打印",
                    "8、打印模块的制单人等人员填写增加记忆功能",
                    "9、凭证列表模块凭证打印优化使用打印模块设置"
                ]
            }
        ]
    },
    {
        "time": "2023/3/24",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增北京、河北、宁波、广东、湖北地区年报财务报表申报",
                    "2、一键取票新增进项发票发票类型选择与小规模季度取票（用增值税发票综合服务平台渠道或税务数字账户渠道取票的）",
                    "3、新增河北增值税发票综合服务平台渠道取票，并且可以选择取进项发票已认证或已认证与未认证的票",
                    "4、一键登录功能新增云南地区（兼容新老版本登录）",
                    "5、一键登录功能新增福建新版登录方式",
                    "6、票据导入匹配数电发票",
                    "7、日记账模块新增筛选功能",
                    "8、修改凭证与预览凭证模块新增左右翻页功能",
                    "9、账套迁移模块新增导入兼容金蝶专业版、速达3000财务软件"
                ]
            }
        ]
    },
    {
        "time": "2023/3/17",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增山西一般纳税人增值税申报",
                    "2、新增安徽地区年报财务报表申报",
                    "3、新增安徽增值税发票综合服务平台渠道取票，并且可以选择取进项发票已认证或已认证与未认证的票",
                    "4、税种认定信息采集功能新增云南地区",
                    "5、日记账模块新增扫描功能",
                    "6、资产负债表重分类新增一级科目重分类功能",
                    "7、优化归档导出表格格式行数限制",
                    "8、票据导入匹配电子税务局格式的差额征税发票"
                ]
            }
        ]
    },
    {
        "time": "2023/3/10",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增浙江、上海、山东、天津、江苏、辽宁、湖南地区年报财务报表申报",
                    "2、新增湖北一般纳税人增值税申报",
                    "3、票据导入匹配差额征税格式发票",
                    "4、优化工资表导入",
                    "5、报税新增批量扣款功能"
                ]
            }
        ]
    },
    {
        "time": "2023/3/3",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、更新安徽验证码登录方式",
                    "2、纳税申报表界面新增登录税局按钮",
                    "3、票据-增值税票-进项模块新增勾选认证按钮",
                    "4、个人生产经营申报表新增减除费用扣除设置功能",
                    "5、存货数量余额表界面新增Excel下载功能",
                    "6、增值税票审核模块新增重置功能",
                    "7、优化库存汇总表导出",
                    "8、账套迁移模块新增导入兼容讯兔财务软件、航天信息-A6财务软件"
                ]
            }
        ]
    },
    {
        "time": "2023/2/24",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、勾选认证功能新增天津地区",
                    "2、新增山西增值税发票综合服务平台渠道取票，并且可以选择取进项发票已认证或已认证与未认证的发票",
                    "3、税种认定信息采集功能新增山西地区",
                    "4、票据模块新增做账习惯设置功能",
                    "5、结账模块新增教育经费、工会经费、捐赠支出风险测算",
                    "6、个人生产经营申报表收入，成本费用，利润调整为可填写"
                ]
            }
        ]
    },
    {
        "time": "2023/2/17",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、一键登录功能新增贵州，陕西，辽宁地区",
                    "2、勾选认证功能新增贵州，陕西，辽宁地区",
                    "3、新增贵州财务软件申报",
                    "4、新增青岛，陕西税务数字账户渠道取票，可获取带有明细的进销项，并且可以选择取进项发票已认证或已认证与未认证的发票",
                    "5、新增辽宁增值税发票综合服务平台渠道取票，并且可以选择取进项发票已认证或已认证与未认证的发票",
                    "6、新增湖北获取销项发票",
                    "7、税种认定信息采集功能新增陕西，辽宁，湖北地区",
                    "8、打印模块新增明细账与总账可选择页码打印"
                ]
            }
        ]
    },
    {
        "time": "2023/2/10",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、银企互联模块新增交通银行",
                    "2、新增贵州、陕西、辽宁一般纳税人增值税申报",
                    "3、调整结账后无打印弹框跳出",
                    "4、优化员工辅助核算模块",
                    "5、优化兼容湖北网厅导出票据格式"
                ]
            }
        ]
    },
    {
        "time": "2023/2/3",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、优化金账师助手可以打开多个页面",
                    "2、新增湖南税务数字账户渠道取票，可获取带有明细的进销项，并且可以选择取进项发票已认证或已认证与未认证的发票",
                    "3、新增贵州、宁波增值税发票综合服务平台渠道取票，并且可以选择取进项发票已认证或已认证与未认证的发票",
                    "4、勾选认证功能新增湖南、宁波地区",
                    "5、税种认定信息采集功能新增贵州地区",
                    "6、小规模增值税减免表新增减按1%征收率征收增值税政策",
                    "7、新增凭证列表模块下载凭证功能",
                    "8、根据加计抵减新政策优化一般纳税人增值税申报表附表四",
                    "9、优化浙江发票导入功能"
                ]
            }
        ]
    },
    {
        "time": "2023/1/13",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增深圳小规模企业增值税、财务报表、企业所得税申报",
                    "2、新增青岛小规模企业增值税、财务报表、企业所得税申报",
                    "3、新增江西财务报表、企业所得税申报",
                    "4、新增房产税、城镇土地使用税申报表",
                    "5、生产经营申报表征收方式默认值调整为查账征收"
                ]
            }
        ]
    },
    {
        "time": "2023/1/13",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，四川本月申报期延期至1月31日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2023/1/6",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增一键登录功能（江苏、上海、浙江、北京、广东、湖南、安徽、福建、河北、天津、山东、江西地区）",
                    "2、新增天津一键取票",
                    "3、新增江西地区社保申报及作废功能",
                    "4、优化小规模增值税纳税申报表取数规则"
                ]
            }
        ]
    },
    {
        "time": "2022/12/30",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增勾选认证功能（江苏、上海、北京、广东、福建、深圳、山东、江西地区）",
                    "2、新增山东一键取票",
                    "3、新增批量风险测算模块",
                    "4、新增批量反结账功能",
                    "5、兼容天津新版本登陆方式（税号+登录人身份证号+密码）",
                    "6、完善票据导入兼容符号问题"
                ]
            }
        ]
    },
    {
        "time": "2022/12/16",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，北京本月申报期延期至12月26日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2022/12/9",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增无形资产、长期待摊费用打印",
                    "2、新增资产负债表、利润表、现金流量表多月份选择连续打印",
                    "3、优化宁波、河北可以选择取进项发票已认证或已认证与未认证的发票",
                    "4、进项发票模板导入新增“勾选状态”识别，匹配增值税综合服务平台进项票已认证格式",
                    "5、票据-进项发票模块新增批量认证与取消认证功能",
                    "6、工资表新增累计个人养老金字段",
                    "7、票据模块兼容二手车销售统一发票进项发票等情况",
                    "8、完善一键取票账套列表进项发票取数规则，根据票据进项发票已认证状态取数",
                    "9、优化结账模块福利费测算"
                ]
            }
        ]
    },
    {
        "time": "2022/12/2",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、优化江苏，上海，广东，北京，福建，深圳，江西可以选择取进项发票已认证或已认证与未认证的发票",
                    "2、新增云南个税申报",
                    "3、新增江西地区一般纳税人增值税申报",
                    "4、新增进项发票列表“认证状态”筛选功能",
                    "5、进项发票模板导入新增“勾选状态”识别",
                    "6、优化批量审核",
                    "7、优化一般纳税人附表二取数规则（第二行取进项已认证的专票）",
                    "8、完善生产经营所得税提交机制"
                ]
            }
        ]
    },
    {
        "time": "2022/11/25",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增青岛社保申报",
                    "2、广东、福建地区一键取票新增进销项可获取明细并可获取全电发票",
                    "3、北京地区一键取票新增可获取全国含有明细的进项发票并且进销项均可获取全电发票",
                    "4、日记账匹配东营农商银行",
                    "5、资产模块固定表头、编码与资产名称两列",
                    "6、账套导入可导入附单据数"
                ]
            }
        ]
    },
    {
        "time": "2022/11/18",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增深圳、青岛地区一般纳税人增值税申报",
                    "2、新增深圳、江西地区一键取票进销项发票",
                    "3、新增青岛地区一键取票销项发票",
                    "4、江苏地区一键取票新增获取全电发票",
                    "5、完善禁用科目显示问题",
                    "6、短信列表模块优化去重",
                    "7、优化扫描功能"
                ]
            }
        ]
    },
    {
        "time": "2022/11/15",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，河南部分地区本月申报期延期至11月25日，广东省广州市、山东省青岛市、重庆市、甘肃省、西藏本月申报期延期至11月28日，辽宁省丹东市、新疆、内蒙古呼和浩特、包头、巴彦淖尔、赤峰本月申报期延期至11月29日，福建省福州市、青海省本月申报期延期至11月30日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2022/11/11",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，福建省福州市本月申报期延期至11月30日。请合理安排时间，及时申报，避免漏报！"
                ]
            },
            {
                "title": "更新通知",
                "list": [
                    "1、新增工资表部门—工程部门",
                    "2、余额表筛选功能联动科目辅助余额表与数量金额余额表",
                    "3、结账模块新增季度计提税金",
                    "4、优化上海取票与兼容全电发票格式",
                    "5、新增凭证录入时新增辅助核算同时可新增单位",
                    "6、完善不同地区报税延期问题",
                    "7、优化固定资产模块"
                ]
            }
        ]
    },
    {
        "time": "2022/11/04",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增一键取票批量导入",
                    "2、升级管理员账号权限",
                    "3、优化导出客户列表",
                    "4、优化浙江报税检查功能",
                    "5、优化库存明细表与库存汇总表"
                ]
            }
        ]
    },
    {
        "time": "2022/10/28",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增无形资产模块",
                    "2、新增长期待摊费用模块",
                    "3、固定资产模块新增数量字段",
                    "4、新增福建小规模增值税申报",
                    "5、新增福建财务报表申报",
                    "6、新增福建企业所得税申报",
                    "7、客户列表右侧新增首字母筛选"
                ]
            }
        ]
    },
    {
        "time": "2022/10/14",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增上海地区一键取票获取全电发票",
                    "2、新增科目名称长度字符",
                    "3、票据-增值税模块兼容全电发票格式",
                    "4、优化报税列表排序",
                    "5、优化导账功能"
                ]
            }
        ]
    },
    {
        "time": "2022/09/30",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增合并凭证",
                    "2、新增印花税添加子目",
                    "3、新增日记账添加收支类型（上缴个人所得税、上缴企业所得税）",
                    "4、优化余额表折叠辅助核算科目",
                    "5、调整红冲发票摘要格式",
                    "6、完善批量删除辅助核算",
                    "7、优化结账检查速度"
                ]
            }
        ]
    },
    {
        "time": "2022/09/23",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增浙江进销项电子专票可获取明细",
                    "2、新增票据-日记账审核模块排序功能",
                    "3、新增票据-日记账审核模块开户行搜索功能",
                    "4、新增一般纳税人增值税纳税申报表下载",
                    "5、新增小规模增值税纳税申报表下载",
                    "6、完善税种采集超时设置"
                ]
            }
        ]
    },
    {
        "time": "2022/09/16",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增福建一般纳税人增值税申报",
                    "2、新增福建印花税申报",
                    "3、新增浙江残保金申报",
                    "4、新增凭证按记账日期重排功能",
                    "5、调整电子税务局申报结果反馈（一对一反馈）",
                    "6、优化账套迁移软件导入"
                ]
            }
        ]
    },
    {
        "time": "2022/09/13",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增浙江地区的残保金申报"
                ]
            }
        ]
    },
    {
        "time": "2022/09/02",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增江苏地区的残保金申报",
                    "2、新增新疆地区个税申报",
                    "3、新增上海进项发票可获取明细（除电子专票外）",
                    "4、新增河北进项电子发票可获取明细",
                    "5、新增广东可获取进项发票（不含明细）",
                    "6、新增福建一键取票进销项（不含明细）",
                    "7、客户列表新增“当前期间”筛选功能",
                    "8、新增凭证汇总表打印支持横向格式",
                    "9、工资表下载用作原始凭证格式把手机号调整为部门"
                ]
            }
        ]
    },
    {
        "time": "2022/08/26",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增城镇垃圾处理费申报表",
                    "2、新增生产经营申报表人员信息部分",
                    "3、一键报税新增广东、安徽、北京、天津、山东地区的残保金申报",
                    "4、新增山东取票可获取明细",
                    "5、新增北京获取销项发票货物明细及省内进项发票（不含货物明细）",
                    "6、新增江苏电子发票可获取明细",
                    "7、新增浙江进项发票可获取明细"
                ]
            }
        ]
    },
    {
        "time": "2022/08/19",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增验证码列表模块",
                    "2、完善社保申报所属期",
                    "3、新增打印设置报表字体大小设置",
                    "4、账套迁移模块匹配云代账新格式",
                    "5、小规模主表第11行公式调整",
                    "6、修复账套导入的凭证删除不了问题",
                    "7、取消多栏账下级科目限制"
                ]
            }
        ]
    },
    {
        "time": "2022/08/12",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增扫描编辑功能",
                    "2、优化票据导入折扣发票功能"
                ]
            }
        ]
    },
    {
        "time": "2022/08/05",
        "content": [
            {
                "title": "重要通知！",
                "list": [
                    "社保符合缓缴政策条件的企业通过财务软件提交扣款，默认全额缴纳，自愿不享受缓缴政策！"
                ]
            }
        ]
    },
    {
        "time": "2022/08/05",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、新增申报时间筛选",
                    "2、优化票据导入",
                    "3、优化凭证模板借贷方向"
                ]
            }
        ]
    },
    {
        "time": "2022/08/01",
        "content": [
            {
                "title": "重要通知！",
                "list": [
                    "印花税自2022年7月1号已经全面调整，申报之前需确保软件印花税纳税期限是否与电子税务局一致。若不一致，请修改税务信息，或者重新点击税种采集（重新采集之后会影响手动添加的税种，采集之后可以再次手动添加）"
                ]
            }
        ]
    },
    {
        "time": "2022/07/29",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1、银企互联模块新增平安银行",
                    "2、根据政策调整印花税表",
                    "3、进度监测、报税状态与电子税务局联动",
                    "4、优化小于1元税款扣款状态为无需扣款",
                    "5、优化结账印花税、税金",
                    "6、优化凭证筛选界面"
                ]
            }
        ]
    },
    {
        "time": "2022/07/22",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.新增批量取票功能",
                    "2.新增积分模块",
                    "3.日记账添加收支类型（上缴城市维护建设税、上缴教育费附加、上缴地方教育费附加）",
                    "4.显示资产负债表重分类设置"
                ]
            }
        ]
    },
    {
        "time": "2022/07/15",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.票据导入增加兼容河北网厅进项发票表格格式",
                    "2.优化小规模主表",
                    "3.优化社保验证码取数机制",
                    "4.优化小税种取数机制"
                ]
            }
        ]
    },
    {
        "time": "2022/07/15",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，江苏省无锡市本月申报期延期至7月29日，安徽省宿州市灵璧、泗县本月申报期延期至7月28日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2022/07/08",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.登陆信息添加主管税务机关",
                    "2.优化生产经营所得税",
                    "3.更新工会经费取数",
                    "4.优化小规模主表取数",
                    "5.完善小税种取数"
                ]
            }
        ]
    },
    {
        "time": "2022/07/01",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.新增增值税票客户.供应商.商品名称搜索功能",
                    "2.新增批量操作复制上月工资可选择征期后一个月",
                    "3.新增零申报记忆功能",
                    "4.更新印花税尾数取消规定",
                    "5.优化发票扫描功能",
                    "6.优化一键取票导入浙江省通用电子发票",
                    "7.调整一般纳税人主表30行公式默认取上月32行数据",
                    "8.调整小规模16行本期应纳税额可修改"
                ]
            }
        ]
    },
    {
        "time": "2022/06/24",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.批量复制上月工资表优化",
                    "2.进项票据导入兼容河北电子普通发票格式",
                    "3.江苏必须检查完成后才能扣款"
                ]
            }
        ]
    },
    {
        "time": "2022/06/17",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，上海本月申报期延期至6月30日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2022/06/17",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.新增批量采集税种",
                    "2.优化申报税种同步税种采集",
                    "3.新增电子税务局作废功能",
                    "4.新增河北、安徽、广东社保申报作废功能",
                    "5.新增搜索高亮功能",
                    "6.优化银企互联"
                ]
            }
        ]
    },
    {
        "time": "2022/06/10",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.新增税种信息采集",
                    "2.优化身份证校验机制",
                    "3.优化工资表",
                    "4.添加凭证汇总表打印"
                ]
            }
        ]
    },
    {
        "time": "2022/06/03",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.添加身份证校验机制",
                    "2.添加工资表打印",
                    "3.员工辅助核算'证件类型'名称更新",
                    "4.完善其他票据摘要",
                    "5、客户列表新增标签搜索",
                    "6.优化获取银行回单"
                ]
            }
        ]
    },
    {
        "time": "2022/05/27",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "1.添加印花税税目",
                    "2.添加社保与生产经营报税模板",
                    "3.调整小规模主表公式",
                    "4.优化银企互联银行回单"
                ]
            }
        ]
    },
    {
        "time": "2022/05/20",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "1.受疫情影响，北京本月申报期延期至5月30日，上海本月申报期延期至5月31日，江苏省无锡市本月申报期延期至5月31日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    },
    {
        "time": "2022/05/13",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.添加社保设置",
                    "2.银企互联模块升级（加入回单相关内容）",
                    "3.减免税申报表优化"
                ]
            }
        ]
    },
    {
        "time": "2022/05/06",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.印花税申报表优化",
                    "2.凭证搜索功能优化",
                    "3.扫描功能优化"
                ]
            }
        ]
    },
    {
        "time": "2022/04/22",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.优化企业会计准则报表",
                    "2.优化个税统计",
                    "3.新增凭证页面搜索筛选功能"
                ]
            }
        ]
    },
    {
        "time": "2022/04/22",
        "content": [
            {
                "title": "更新通知",
                "list": [
                    "1.优化印花税纳税申报表",
                    "2.优化批量下载",
                    "3.优化发票扫描功能"
                ]
            }
        ]
    },
    {
        "time": "2022/04/20",
        "content": [
            {
                "title": "报税延期通知",
                "list": [
                    "受疫情影响，江苏【无锡、徐州、苏州（含保税区和园区）、镇江、宿迁、南通】本月申报期延期至4月30日，上海本月申报期延期至4月29日，浙江省金华市本月申报期延期至4月25日，广东省广州本月申报期延期至4月27日。请合理安排时间，及时申报，避免漏报！"
                ]
            }
        ]
    }
];
// @ts-ignore
export default updateLog;